/* Siora custom newsletter / discount popup.
   Email capture uses the theme's native {% form 'customer' %} submitted normally, so
   Shopify handles spam protection (hCaptcha) and saves the subscriber reliably. On the
   page it returns to, the popup re-opens straight into the "code unlocked" state.
   Frequency-capped, keyboard accessible. Force-preview: ?si_popup=1 (capture) / ?si_popup=success. */
(function () {
  'use strict';

  var SEEN_KEY = 'si_np_dismissed_at';
  var SUB_KEY = 'si_np_subscribed';

  function init(root) {
    if (!root || root.dataset.siNpBound) return;
    root.dataset.siNpBound = '1';

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-si-np-config]').textContent); } catch (e) {}

    var modal = root.querySelector('.si-np__modal');
    var form = root.querySelector('.si-np__form');
    var submitBtn = root.querySelector('[data-si-np-submit]');
    var emailInput = root.querySelector('[data-si-np-email]');
    var captureEl = root.querySelector('[data-si-np-capture]');
    var successEl = root.querySelector('[data-si-np-success]');
    var copyBtn = root.querySelector('[data-si-np-copy]');
    var copiedEl = root.querySelector('[data-si-np-copied]');
    var codeEl = root.querySelector('[data-si-np-code]');
    var closers = root.querySelectorAll('[data-si-np-close]');

    var params = new URLSearchParams(location.search);
    var forceCapture = params.get('si_popup') === '1';
    var forceSuccess = params.get('si_popup') === 'success';
    var justSubscribed = !!root.querySelector('[data-si-np-posted]') || params.get('customer_posted') === 'true';

    function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

    function shouldAutoShow() {
      if (forceCapture) return true;
      if (!cfg.enabled) return false;
      if (read(SUB_KEY)) return false;
      var days = Number(cfg.frequency || 0);
      if (days > 0) {
        var last = Number(read(SEEN_KEY) || 0);
        if (last && (Date.now() - last) < days * 86400000) return false;
      }
      return true;
    }

    var lastFocus = null;
    function open() {
      if (root.hasAttribute('hidden')) root.removeAttribute('hidden');
      lastFocus = document.activeElement;
      document.documentElement.classList.add('si-np-lock');
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.addEventListener('keydown', onKey);
      var el = successEl.hasAttribute('hidden') ? emailInput : copyBtn;
      if (el) setTimeout(function () { try { el.focus({ preventScroll: true }); } catch (e) {} }, 320);
    }
    function close() {
      root.classList.remove('is-open');
      document.documentElement.classList.remove('si-np-lock');
      document.removeEventListener('keydown', onKey);
      if (!read(SUB_KEY)) store(SEEN_KEY, String(Date.now()));
      setTimeout(function () { root.setAttribute('hidden', ''); }, 300);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'Tab') trap(e);
    }
    function trap(e) {
      var f = modal.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])');
      var vis = [];
      for (var i = 0; i < f.length; i++) if (f[i].offsetParent !== null) vis.push(f[i]);
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function showSuccess() {
      captureEl.setAttribute('hidden', '');
      successEl.removeAttribute('hidden');
      store(SUB_KEY, '1');
    }

    // native submit → Shopify handles hCaptcha + saves the subscriber, then reloads.
    if (form && submitBtn) {
      form.addEventListener('submit', function () { submitBtn.classList.add('is-loading'); });
    }

    // copy the code — show feedback immediately, copy in the background (robust across browsers)
    if (copyBtn && codeEl) {
      copyBtn.addEventListener('click', function () {
        var code = (codeEl.textContent || '').trim();
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).catch(function () { legacy(code); });
          } else { legacy(code); }
        } catch (e) { legacy(code); }
        if (copiedEl) {
          copiedEl.removeAttribute('hidden');
          setTimeout(function () { copiedEl.setAttribute('hidden', ''); }, 1600);
        }
      });
    }
    function legacy(text) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
    }

    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);

    // decide what to show on load
    if (justSubscribed || forceSuccess) {
      showSuccess();
      open();
    } else if (shouldAutoShow()) {
      setTimeout(open, forceCapture ? 0 : Math.max(0, Number(cfg.delay || 0)) * 1000);
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-si-np]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
